const scrollIntoField = (id: string, block?: ScrollLogicalPosition, inline?: ScrollLogicalPosition) => {
  const element = document.getElementById(id)
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block, inline })
  }
}

export { scrollIntoField }
